<template>
  <div>
    <v-list dense>
      <v-list-item
          :key="'ticket_detail_0'"
          dense
      >
        <v-list-item-content>
          <v-list-item-title class="font-weight-bold">ID запроса:</v-list-item-title>
        </v-list-item-content>
        <v-list-item-action>
          <v-skeleton-loader
              v-if="loading"
              type="text"
              width="100"
          />
          <div v-else>{{detail.uid}}</div>
        </v-list-item-action>
      </v-list-item>
      <v-divider
          :key="'ticket_detail_line_1_1'"
      ></v-divider>
      <v-list-item
          :key="'ticket_detail_1_1'"
          dense
      >
        <v-list-item-content>
          <v-list-item-title class="font-weight-bold">Номер запроса:</v-list-item-title>
        </v-list-item-content>
        <v-list-item-action>
          <v-skeleton-loader
              v-if="loading"
              type="text"
              width="100"
          />
          <div v-else>{{detail.id}}</div>
        </v-list-item-action>
      </v-list-item>
      <v-divider
          :key="'ticket_detail_line_0'"
      ></v-divider>
      <v-list-item
          :key="'ticket_detail_1'"
          dense
      >
        <v-list-item-content>
          <v-list-item-title class="font-weight-bold">Тип запроса:</v-list-item-title>
        </v-list-item-content>
        <v-list-item-action>
          <v-skeleton-loader
              v-if="loading"
              type="text"
              width="100"
          />
          <div v-else>{{detail.type}}</div>
        </v-list-item-action>
      </v-list-item>
      <v-divider
          :key="'ticket_detail_line_2'"
      ></v-divider>
      <v-list-item
          :key="'ticket_detail_2'"
      >
        <v-list-item-content>
          <v-list-item-title class="font-weight-bold">Продукт:</v-list-item-title>
        </v-list-item-content>
        <v-list-item-action>
          <v-skeleton-loader
              v-if="loading"
              type="text"
              width="100"
          />
          <div v-else>{{detail.product}}</div>
        </v-list-item-action>
      </v-list-item>
      <v-divider
          :key="'ticket_detail_line_3'"
      ></v-divider>
      <v-list-item
          :key="'ticket_detail_3'"
      >
        <v-list-item-content>
          <v-list-item-title class="font-weight-bold">Приоритет:</v-list-item-title>
        </v-list-item-content>
        <v-list-item-action>
          <v-skeleton-loader
              v-if="loading"
              type="text"
              width="100"
          />
          <div v-else>
            <div v-if="progress">
              <v-progress-circular
                  indeterminate
                  color="primary"
                  size="15"
                  width="2"
                  class="mr-3"
              ></v-progress-circular>
              Обновление
            </div>
            <v-menu
                left
                bottom
                min-width="300"
                max-height="400"
                v-else
            >
              <template v-slot:activator="{ on }">
                <div v-on="on" @click="getPriorities">
                  <div class="primary--text user_action">{{detail.priority}}</div>
                </div>
              </template>
              <template>
                <v-skeleton-loader
                    type="list-item@3"
                    width="300"
                    v-if="load.list"
                />
                <v-list v-else class="panel">
                  <div v-for="(priority_x, index) in priority" :key="'priority_x_'+index">
                    <v-divider
                        v-if="index > 0"
                        :key="'priority_x_line_'+index"
                    ></v-divider>
                    <v-list-item
                        :key="'priority_x_item_'+index"
                        @click="$emit('change-priority', priority_x.value, priority_x.name)"
                    >
                      <v-list-item-content>
                        <v-list-item-title v-text="priority_x.name"/>
                      </v-list-item-content>
                    </v-list-item>
                  </div>
                </v-list>
              </template>
            </v-menu>
          </div>
        </v-list-item-action>
      </v-list-item>
      <v-divider
          :key="'ticket_detail_line_4'"
      ></v-divider>
      <v-list-item
          :key="'ticket_detail_5'"
      >
        <v-list-item-content>
          <v-list-item-title class="font-weight-bold">Дедлайн:</v-list-item-title>
        </v-list-item-content>
        <v-list-item-action>
          <v-skeleton-loader
              v-if="loading"
              type="text"
              width="100"
          />
          <div v-else
               v-text="!detail.deadline ? 'Не установлен' : getDate(detail.deadline)"
               :class="!detail.deadline ? 'thunderbird--text' : ''"
          />
        </v-list-item-action>
      </v-list-item>
      <v-divider
          :key="'ticket_detail_line_5'"
      ></v-divider>
      <v-list-item
          :key="'ticket_detail_6'"
      >
        <v-list-item-content>
          <v-list-item-title class="font-weight-bold">Ответственный сотрудник Импелтех:</v-list-item-title>
        </v-list-item-content>
        <v-list-item-action>
          <v-skeleton-loader
              v-if="loading"
              type="text"
              width="100"
          />
          <template v-else>
            <span class="thunderbird--text" v-if="detail.employee.name === ' '">Пока не назначен</span>
            <v-chip
                pill
                v-else
                color="catskill"
            >
              <v-avatar left>
                <v-icon v-if="detail.employee.avatar === ''" color="primary">mdi-account-circle</v-icon>
                <v-img v-else :src="detail.employee.avatar"/>
              </v-avatar>
              {{ detail.employee.name }}
            </v-chip>
          </template>
        </v-list-item-action>
      </v-list-item>
      <v-divider
          :key="'ticket_detail_line_6'"
      ></v-divider>
      <v-list-item
          :key="'ticket_detail_ex_1'"
      >
        <v-list-item-content>
          <v-list-item-title class="font-weight-bold">Список отслеживания:</v-list-item-title>
        </v-list-item-content>
        <v-list-item-action>
          <v-skeleton-loader
              v-if="loading"
              type="text"
              width="100"
          />
          <div v-else>
            <v-chip
                v-for="(user_track, index) in detail.tracking"
                :key="'user_track_ticket_item_'+index"
                class="mr-3"
                :close="user_track.close"
                color="catskill"
                @click:close="delTeamTrack(index)"
            >
              {{ user_track.name }}
            </v-chip>
            <template>
              <v-tooltip left>
                <template v-slot:activator="{ on }">
                  <v-btn icon color="green" small v-on="on" @click="getTeam">
                    <v-icon small>mdi-plus</v-icon>
                  </v-btn>
                </template>
                <span>Добавить в список</span>
              </v-tooltip>
            </template>
          </div>
        </v-list-item-action>
      </v-list-item>
      <v-divider
          :key="'ticket_detail_line_ex_1'"
      ></v-divider>
      <v-list-item
          :key="'ticket_detail_4'"
      >
        <v-list-item-content>
          <v-list-item-title class="font-weight-bold">Статус:</v-list-item-title>
        </v-list-item-content>
        <v-list-item-action>
          <v-skeleton-loader
              v-if="loading"
              type="text"
              width="100"
          />
          <v-chip
              v-else
              small
              :color="detail.status === 0 ? '' : detail.status === 1 ? 'warning' : detail.status === 2 ? 'success' : 'info'"
              v-text="detail.status === 0 ? 'В работе' : detail.status === 1 ? 'На проверке' : detail.status === 2 ? 'Закрыт' : 'На уточнении'"
          />
        </v-list-item-action>
      </v-list-item>
      <v-divider
          :key="'ticket_detail_line_ex_2'"
      ></v-divider>
      <v-list-item
          :key="'ticket_detail_ex_5'"
      >
        <v-list-item-content>
          <v-list-item-title class="font-weight-bold">Источник запроса:</v-list-item-title>
        </v-list-item-content>
        <v-list-item-action>
          <v-skeleton-loader
              v-if="loading"
              type="text"
              width="100"
          />
          <span v-else v-text="!detail.source ? 'WEB' : detail.source === 1 ? 'Почта' : 'ELMA'"/>
        </v-list-item-action>
      </v-list-item>
    </v-list>

    <!--GET USERS-->
    <v-bottom-sheet scrollable v-model="track.status" inset>
      <v-sheet>
        <v-card height="100%" class="overflow-y-auto" tile :loading="loadTeam">
          <v-toolbar flat class="toolbar">
            <v-toolbar-title>
              Добавить в отслеживание
            </v-toolbar-title>
            <v-spacer></v-spacer>
            <v-btn icon
                   @click="track.status = false"
            >
              <v-icon>mdi-close</v-icon>
            </v-btn>
          </v-toolbar>
          <v-divider></v-divider>
          <v-list :disabled="loadTeam">
            <v-list-item
                :key="'user_track_customer_item_'+index"
                v-for="(user_team, index) in track.list"
                @click="addTeamTrack(user_team)"
            >
              <v-list-item-content>
                <v-list-item-title>{{ user_team.name }}</v-list-item-title>
              </v-list-item-content>
            </v-list-item>
          </v-list>
        </v-card>
      </v-sheet>
    </v-bottom-sheet>
  </div>
</template>

<script>
export default {
  name: 'TicketDetail',
  props: ['loading', 'detail', 'progress'],
  data: () => ({
    load: {
      list: true
    },
    priority: [],
    track: {
      status: false,
      list: []
    },
    loadTeam: false
  }),
  methods: {
    getDate(unix) {
      console.log(unix)
      let date = new Date(unix * 1000);
      let hours = date.getHours();
      let minutes = "0" + date.getMinutes();
      let day = date.getDate();
      let month = date.getMonth() + 1;
      let year = date.getFullYear();
      if (day < 10) {
        day = '0' + day;
      }
      if (month < 10) {
        month = '0' + month;
      }
      let formattedTime = hours + ':' + minutes.substr(-2);
      let formattedDate = day + '-' + month + '-' + year;
      return formattedDate + ' ' + formattedTime;
    },
    getPriorities() {
      this.priority = [];
      this.load.list = true;
      this.$http.get(`${this.$serverApiLink}config/priorities`).then(
          response => {
            window.console.log(response.data.data);
            this.createPrioritiesArray(response.data.data);
            this.load.list = false;
          }
      ).catch(
          error => {
            this.$store.commit('setSnack', {
              status: true,
              code: error.response.status,
              message: error.response.data.message,
              type: 'error'
            });
            window.console.log(error.response)
            this.load.list = false;
          }
      );
    },
    createPrioritiesArray(array) {
      if (array) {
        for (let i = 0; i < array.length; i++) {
          if (array[i].name !== this.detail.priority) {
            this.priority.push({name: array[i].name, value: array[i].ID})
          }
        }
      }
    },
    getTeam() {
      this.$store.commit('setGlobalLoading', true);
      this.$http.get(`${this.$serverApiLink}config/team`).then(
          response => {
            window.console.log(response.data.data);
            this.track = {
              status: true,
              list: response.data.data
            }
            this.$store.commit('setGlobalLoading', false);
          }
      ).catch(
          error => {
            this.$store.commit('setSnack', {
              status: true,
              code: error.response.status,
              message: error.response.data.message,
              type: 'error'
            });
            window.console.log(error.response)
            this.$store.commit('setGlobalLoading', false);
          }
      );
    },
    addTeamTrack(item) {
      this.loadTeam = true;
      this.$http.post(`${this.$serverApiLink}ticket/add_tracking`, {
        "id": item.id,
        "ticket": this.detail.uid
      }).then(
          response => {
            window.console.log(response.data.data);
            this.detail.tracking.push({
              name: item.name,
              id: item.id,
              track: response.data.id,
              close: true
            });
            this.track = {
              status: false,
              list: []
            };
            this.$store.commit('setSnack', {
              status: true,
              code: 200,
              message: 'Пользователь добавлен в список отслеживания',
              type: 'success'
            });
            this.loadTeam = false;
          }
      ).catch(
          error => {
            this.$store.commit('setSnack', {
              status: true,
              code: error.response.status,
              message: error.response.data.message,
              type: 'error'
            });
            window.console.log(error.response)
            this.loadTeam = false;
          }
      );
    },
    delTeamTrack(index) {
      this.$store.commit('setGlobalLoading', true);
      this.$http.post(`${this.$serverApiLink}ticket/del_tracking`, {
        "id": this.detail.tracking[index].id,
        "ticket": this.detail.uid,
        "track": this.detail.tracking[index].track,
      }).then(
          response => {
            window.console.log(response.data.data);
            this.detail.tracking.splice(index, 1);
            this.$store.commit('setSnack', {
              status: true,
              code: 200,
              message: 'Пользователь удален из списка отслеживания',
              type: 'success'
            });
            this.$store.commit('setGlobalLoading', false);
          }
      ).catch(
          error => {
            this.$store.commit('setSnack', {
              status: true,
              code: error.response.status,
              message: error.response.data.message,
              type: 'error'
            });
            window.console.log(error.response)
            this.$store.commit('setGlobalLoading', true);
          }
      );
    }
  }
}
</script>

<style>
.user_action {
  cursor: pointer;
  border-bottom: 1px dashed;
}
</style>